<template>
  <div class="login-register-container" @click="handleContainerClick">
    <!-- Background image container -->
    <div class="background-image"></div>

    <!-- Common Header (Always Visible) -->
    <div class="common-header">
      <!-- Top Logo -->
      <div class="top-logo-container">
        <!-- Use dynamic logo from store if available, otherwise fallback -->
        <img :src="$store.state.appInfo.site_logo ? $store.state.appInfo.site_logo : '/static/image/hth/logo.png'" alt="Logo" class="top-logo" />
        <div class="logo-text">{{ $store.state.appInfo.title || '华体会' }}</div>
      </div>
      <!-- Partner Block -->
      <div class="partner-block">
        <img src="/static/image/hth/partners.png" alt="合作伙伴" class="partner-image">
      </div>
    </div>

    <!-- Unified View Container (Replaces separate login/register views) -->
    <div class="unified-view">
      <!-- Unified Form -->
      <div class="unified-form">
        <!-- Username Input (Always Visible) -->
        <div class="input-wrapper">
          <div class="input-group">
            <img src="/static/image/hth/user.png" alt="User Icon" class="input-icon" />
            <!-- Bind to computed property -->
            <input type="text" v-model="username" placeholder="用户名" autocomplete="off" />
          </div>
          <div class="input-hint" v-if="infoType === 1">用户名长度限制5-11位小写字母加数字组合</div>
        </div>

        <!-- Password Input (Always Visible) -->
        <div class="input-wrapper">
          <div class="input-group">
            <img src="/static/image/hth/password.png" alt="Password Icon" class="input-icon" />
             <!-- Bind to computed property -->
            <input type="password" v-model="password" placeholder="密码" autocomplete="new-password" />
          </div>
        </div>

        <!-- Confirm Password Input (Register Only) -->
        <div class="input-wrapper" v-if="infoType === 1">
          <div class="input-group">
            <img src="/static/image/hth/password.png" alt="Confirm Password Icon" class="input-icon" />
            <input type="password" v-model="registerInfo.confirmPass" placeholder="确认密码" autocomplete="new-password" />
          </div>
        </div>

        <!-- Real Name Input (Register Only) -->
        <!-- <div class="input-wrapper" v-if="infoType === 1">
          <div class="input-group">
            <img src="/static/image/hth/user.png" alt="Real Name Icon" class="input-icon" />
            <input type="text" v-model="registerInfo.realname" placeholder="真实姓名" />
          </div>
        </div> -->

        <!-- Payment Password Input (Register Only) -->
        <div class="input-wrapper" v-if="infoType === 1">
          <div class="input-group">
            <img src="/static/image/hth/password.png" alt="Payment Password Icon" class="input-icon" />
            <input type="password" v-model="registerInfo.paypassword" placeholder="支付密码" autocomplete="new-password" />
          </div>
        </div>

        <!-- Login Button (Login Only) -->
        <button class="action-button login-button" @click="login()" v-if="infoType === 0">登 录</button>

        <!-- Register Button (Register Only) -->
        <button class="action-button register-button" @click="register()" v-if="infoType === 1">注 册</button>
      </div>

      <!-- Bottom Links Area -->
      <div class="bottom-links-area">
        <!-- Login Bottom Links (Login Only) -->
        <div class="bottom-links login-bottom-links" v-if="infoType === 0">
          <div class="link-item" @click="changInfoType(1)">
            <img src="/static/image/hth/register.png" alt="Register" />
            <span>立即注册</span>
          </div>
          <div class="link-item" @click="guestLogin()">
            <img src="/static/image/hth/travelers.png" alt="Guest" />
            <span>游客进入</span>
          </div>
          <div class="link-item" @click="forgotPassword()">
            <img src="/static/image/hth/customer.png" alt="Forgot Password" />
            <span>找回账号</span>
          </div>
        </div>

        <!-- Register Bottom Links (Register Only) -->
        <div class="bottom-links register-bottom-links" v-if="infoType === 1">
          <div class="link-item" @click="changInfoType(0)">
            <img src="/static/image/hth/register.png" alt="Login" />
            <span>前往登陆</span>
          </div>
          <div class="link-item" @click="guestLogin()">
            <img src="/static/image/hth/travelers.png" alt="Guest" />
            <span>游客进入</span>
          </div>
          <div class="link-item" @click="forgotPassword()">
            <img src="/static/image/hth/customer.png" alt="Forgot Password" />
            <span>找回账号</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div id="app-footer">
       <!-- Existing Footer Content -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      registerInfo: { name: '', password: '', confirmPass: '', realname: '', paypassword: '' },
      loginInfo: { name: '', password: '' },
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      infoType: 0,
      psw1: true,
      psw2: true,
      psw3: true,
      pid: '',
      isRegistering: false,
    };
  },
  computed: {
    username: {
      get() {
        return this.infoType === 0 ? this.loginInfo.name : this.registerInfo.name;
      },
      set(value) {
        if (this.infoType === 0) {
          this.loginInfo.name = value;
        } else {
          this.registerInfo.name = value;
        }
      }
    },
    password: {
      get() {
        return this.infoType === 0 ? this.loginInfo.password : this.registerInfo.password;
      },
      set(value) {
        if (this.infoType === 0) {
          this.loginInfo.password = value;
        } else {
          this.registerInfo.password = value;
        }
      }
    }
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.infoType = parseInt(query.type);
    }
    if (query.pid) {
      that.pid = query.pid;
    }
  },
  methods: {
    handleContainerClick(event) {
      const isInput = event.target.tagName === 'INPUT' || 
                     event.target.closest('.input-group');
      
      if (!isInput) {
        document.activeElement.blur();
      }
    },
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;
      let info = that.registerInfo;

      if (that.isRegistering) {
        that.$parent.showTost(0, '注册请求已提交，请勿重复操作！');
        return;
      }

      // Username Validation
      const usernameRegex = /^[a-z0-9]{5,11}$/;
      if (!info.name || !usernameRegex.test(info.name)) {
        that.$parent.showTost(0, ' 用户名需为5-11位小写字母或数字组合！');
        return;
      }

      // Password Validation
      if (!info.password || info.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的密码长度，最少6位！');
        return;
      }
      if (!info.confirmPass || info.confirmPass != info.password) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }

      // Re-added Real Name Validation
      //if (!info.realname || info.realname.length < 2) {
        //that.$parent.showTost(0, '请输入您的真实姓名!');
        //return;
      //}

      // Re-added Payment Password Validation
      if (!info.paypassword || info.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
        return;
      }

      that.$parent.showLoading();
      that.isRegistering = true;

      // Construct data to send (including re-added fields)
      let registerData = {
          name: info.name,
          password: info.password,
          confirmPass: info.confirmPass,
          realname: info.realname,
          paypassword: info.paypassword,
          ...(that.pid && { pid: that.pid })
      };

      that.$apiFun.register(registerData).then(res => {
        that.$parent.showTost(1, res.message);
        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();
          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
        that.isRegistering = false;
      }).catch(err => {
          console.error("Registration failed:", err);
          that.$parent.showTost(0, '注册失败，请稍后再试。');
          that.$parent.hideLoading();
          that.isRegistering = false;
      });
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
          return;
        }
        sessionStorage.setItem('token', res.data.api_token);
        that.$store.commit('changToken');
        that.$parent.getUserInfo();
        that.$parent.openDaoTime();
        that.$parent.refreshBalance();
        that.$parent.goNav('/');
        that.$parent.hideLoading();
      }).catch(err => {
          console.error("Login failed:", err);
          that.$parent.showTost(0, '登录失败，请稍后再试。');
          that.$parent.hideLoading();
      });
    },
    guestLogin() {
      this.$parent.goNav('/');
      console.log("Guest Login clicked");
    },
    forgotPassword() {
      console.log("Forgot Password clicked");
      this.$parent.openKefu();
    }
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
/* Remove existing styles and add new ones */
/* Import or define base styles if needed */

/* Apply background image */
.login-register-container {
  position: relative;
  width: 100%;
  min-height: 100vh; /* Ensure it covers the full viewport height */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Align items to the top */
  padding-top: 8vh; /* Adjusted top padding */
  box-sizing: border-box;
  overflow: hidden; /* Hide overflow from background */
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/static/image/hth/login_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1; /* Place background behind content */
  filter: brightness(0.6); /* Adjusted brightness */
}

/* Login View Specific Styles */
.login-view {
  width: 85%;
  max-width: 380px; /* Reverted max-width */
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1; /* Ensure content is above background */
}

/* Top Logo Styles */
.top-logo-container {
  display: flex;
  flex-direction: column; /* Stack logo and text vertically */
  align-items: center;
  margin-bottom: 25px; /* Adjusted space */
}

.top-logo {
  width: 55px; /* Adjusted size */
  height: auto;
  margin-bottom: 8px; /* Adjusted space */
}

.logo-text {
  color: #ffffff;
  font-size: 22px; /* Adjusted size */
  font-weight: bold;
}

/* Partner Block Styles */
.partner-block {
  width: 100%;
  border-radius: 20px; /* Keep border-radius */
  margin-bottom: 25px; /* Keep space */
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25); /* Keep shadow */
  position: relative;
  overflow: hidden; /* Ensure image respects border-radius */
}

/* New style for the combined partner image */
.partner-image {
  display: block; /* Remove extra space below image */
  width: 100%;   /* Make image fill the container */
  height: auto;  /* Maintain aspect ratio */
}

/* Login Form Styles */
.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Removed padding and box-sizing */
}

.input-group {
  width: 100%;
  height: 55px; /* Explicit height */
  background-color: rgba(50, 50, 50, 0.3); /* Adjusted background */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 20px; /* Adjusted border-radius */
  margin-bottom: 18px; /* Adjusted space */
  display: flex;
  align-items: center;
  padding: 0 20px; /* Adjusted padding */
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}

.input-icon {
  width: 18px; /* Adjusted size */
  height: 18px;
  margin-right: 12px; /* Adjusted space */
  opacity: 0.6; /* Adjusted opacity */
}

.input-group input {
  flex-grow: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 15px; /* Adjusted size */
  padding: 15px 0; /* Keep vertical padding */
  height: 100%; /* Ensure input fills height */
  line-height: normal; /* Reset line-height */
}

.input-group input::placeholder {
  color: #b0b0b0; /* Adjusted color */
  opacity: 1;
}

.login-button {
  width: 100%;
  height: 55px; /* Explicit height */
  /* Updated background color to gradient */
  background: linear-gradient(to bottom, #d8c2a9, #c8ae8f); /* Light brown/gold gradient */
  color: #ffffff;
  border: none;
  border-radius: 20px; /* Adjusted border-radius */
  padding: 0; /* Reset padding */
  font-size: 17px; /* Adjusted size */
  font-weight: 600; /* Adjusted weight */
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25);
  letter-spacing: 4px; /* Added letter spacing */
  display: flex; /* Center text */
  align-items: center;
  justify-content: center;
}

.login-button:hover {
  /* Adjusted hover background */
  background: linear-gradient(to bottom, #c8ae8f, #b89a76); /* Darker gradient on hover */
}

/* Bottom Links Styles */
.bottom-links {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start; /* Align items to top to match image */
  margin-top: 15px; /* Adjusted space */
  padding: 0 10px; /* Add some horizontal padding */
}

.link-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-align: center;
  flex: 1; /* Allow items to take equal space */
}

.link-item img {
  width: 28px; /* Adjusted icon size */
  height: 28px;
  margin-bottom: 6px; /* Adjusted space */
  opacity: 0.9; /* Adjusted opacity */
}

.link-item span {
  color: #e0e0e0; /* Adjusted color (brighter) */
  font-size: 12px; /* Keep size */
  font-weight: 500;
}

/* --- Keep existing styles for registration view and footer --- */
.registration-view {
  /* Existing styles... */
}

#app-footer {
  /* Existing styles... */
  /* Ensure footer is positioned correctly relative to the new layout */
  /* You might need to adjust its position/styling if it overlaps */
   position: absolute; /* Example: fix to bottom if needed */
   bottom: 0;
   width: 100%;
   /* ... other existing footer styles ... */
   display: none; /* Hide footer in login view as per image */
}

/* Ensure footer visibility is handled correctly based on view if needed elsewhere */
.login-register-container:has(.login-view) #app-footer {
  display: none;
}

/* Common Header Styles */
.common-header {
  width: 85%; /* Adjusted width */
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.return-link {
    width: 100%;
    text-align: left;
    color: #b0b0b0;
    font-size: 14px;
    margin-bottom: 15px; /* Space below return link */
    cursor: pointer;
    padding-left: 10px; /* Align roughly with form */
}

.register-form {
   margin-bottom: 20px; /* Add margin at the bottom if needed */
}

/* Input Styles (Shared) - Ensure margin is on wrapper */
.input-wrapper {
  width: 100%;
  margin-bottom: 15px; /* Consistent spacing */
}

.input-hint {
  color: #b0b0b0;
  font-size: 11px;
  padding-left: 20px;
  margin-top: 5px;
}

/* Action Button Styles (Shared) - Re-applying for certainty */
.action-button {
  width: 100%;
  height: 55px;
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 0;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, background 0.3s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25);
  letter-spacing: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
    margin-top: 10px;
}

/* Login Button styles - Keep as is */
.login-button {
  background: linear-gradient(to bottom, #d8c2a9, #c8ae8f);
}

.login-button:hover {
  background: linear-gradient(to bottom, #c8ae8f, #b89a76);
}

/* Register Button - Apply same styles as Login Button */
.register-button {
  /* Use the same gradient background as login */
  background: linear-gradient(to bottom, #d8c2a9, #c8ae8f);
}

.register-button:hover {
   /* Use the same darker gradient on hover as login */
   background: linear-gradient(to bottom, #c8ae8f, #b89a76);
}

/* Bottom Links General Styles */
.bottom-links {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  margin-top: 20px; /* Adjusted margin for spacing */
  padding: 0 10px;
}

.link-item {
  /* ... (link-item base styles remain the same) ... */
}

.link-item img {
 /* ... (img styles remain the same) ... */
}

.link-item span {
  /* ... (span styles remain the same) ... */
}

/* Remove Registration View Specific Return Link Style */
/* .return-link { ... } */

/* Footer Hiding Logic - Keep as is */
#app-footer {
   position: absolute;
   bottom: 0;
   width: 100%;
   display: none;
}

/* Unified View Container Styles */
.unified-view {
  width: 85%; /* Use same width as header */
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
}

/* Unified Form Styles */
.unified-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
   margin-bottom: 20px; /* Space below form before links */
}

/* Bottom Links Area Styles */
.bottom-links-area {
    width: 100%;
    margin-top: 15px; /* Consistent margin above links */
}

</style>



// WEBPACK FOOTER //
// src/components/login.vue